import {Book, WorkBook} from "../Types/Book.interface";
import {Docs, SearchResult} from "../Types/SearchResult.interface";

async function GetOneBook(key: string): Promise<Book> {
    try {
        const response = await fetch(`http://openlibrary.org/${key}.json`);

        if (!response.ok) {
            throw new Error('Book not found');
        }

        const book: Book = await response.json();
        return book;

    } catch (error) {
        throw error;
    }
}
async function GetWorksBook(key: string): Promise<WorkBook> {
    try {
        const response = await fetch(`http://openlibrary.org/${key}.json`);

        if (!response.ok) {
            throw new Error('Book not found');
        }

        const book: WorkBook = await response.json();
        return book;

    } catch (error) {
        throw error;
    }
}

async function QuickSearchBook(querry: string): Promise<SearchResult> {
    try {
        const response = await fetch(`https://openlibrary.org/search.json?q=${querry}`);

        if (!response.ok) {
            throw new Error('not found');
        }

        const bookList: SearchResult = await response.json();
        return bookList;

    } catch (error) {
        throw error;
    }
}
async function QuickSearchOneBook(querry: string): Promise<Docs> {
    try {
        const response = await fetch(`https://openlibrary.org/search.json?q=${querry}`);

        if (!response.ok) {
            throw new Error('not found');
        }

        const book: SearchResult = await response.json();
        return book.docs[0];

    } catch (error) {
        throw error;
    }
}

async function GetLastestBooks(): Promise<SearchResult> {
    try {
        const response = await fetch(`https://openlibrary.org/search.json?q=sort=new&page=1&limit=10`);

        if (!response.ok) {
            throw new Error('not found');
        }

        const bookList: SearchResult = await response.json();
        return bookList;

    } catch (error) {
        throw error;
    }
}


async function GetBookCover(size:string, cover_i: number | undefined): Promise<string> {
  return ` https://covers.openlibrary.org/b/id/${cover_i}-${size}.jpg`
}


export {GetOneBook, GetWorksBook, QuickSearchBook, GetBookCover, GetLastestBooks,QuickSearchOneBook}